(() => {
  document.querySelectorAll('[data-bb-print-file]').forEach((root) => {
    const WIDTH = Number(root.dataset.width) || 1920;
    const HEIGHT = Number(root.dataset.height) || 1080;
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const button = root.querySelector('[data-print-download]');
    const status = root.querySelector('[data-print-status]');
    const productId = root.dataset.productId;
    let quietAfter = 0;
    let exporting = false;
    let lastState = '';
    let finishedMessage = '';
    let variantRedraw;
    const visible = (element) => Boolean(element.getClientRects().length) && getComputedStyle(element).visibility !== 'hidden';
    const getCanvas = () => document.getElementById('pplr_canvas');
    const designOption = root.dataset.printDesignOption;
    const syncDesign = () => {
      if (!designOption) return true;
      const app = document.getElementById(`pplr-${productId}`);
      const product = document.querySelector(`product-info[data-product-id="${productId}"]`);
      const field = [...(product?.querySelectorAll('variant-selects fieldset') || [])].find(
        (element) => element.querySelector('[data-selected-swatch-value]')?.dataset.selectedSwatchValue === designOption
      );
      const chosen = field?.querySelector('input:checked');
      const property = `properties[${designOption}]`;
      const choices = [...(app?.querySelectorAll('.pplr-swatch-element[data-val]') || [])].filter(
        (element) => element.getAttribute('name') === property
      );
      const swatch = choices.find((element) => element.dataset.val === chosen?.value);
      if (!chosen || !swatch) return false;
      // Zepto's image choices also select the matching Shopify variant.
      // Remove the duplicate model selector only when all images are available.
      if ([...field.querySelectorAll('input[type="radio"]')].every(
        (input) => choices.some((element) => element.dataset.val === input.value)
      )) {
        field.hidden = true;
        field.style.display = 'none';
      }
      choices.forEach((element) => {
        element.setAttribute('role', 'button');
        element.setAttribute('tabindex', '0');
        element.setAttribute('aria-label', element.dataset.val);
        element.setAttribute('aria-pressed', String(element.classList.contains('selected')));
      });
      if (!swatch.classList.contains('selected')) {
        swatch.click();
        quietAfter = Date.now() + 1000;
        finishedMessage = '';
      }
      return swatch.classList.contains('selected');
    };
    const state = () => {
      const app = document.getElementById(`pplr-${productId}`);
      const canvas = getCanvas();
      if (app && root.dataset.uploadRequired === 'true') {
        const upload = app.querySelector('input[type="file"][required]');
        if (!upload?.files?.length) return 'photo';
      }
      if (!app || !(canvas instanceof HTMLCanvasElement)) return 'loading';
      if (!syncDesign()) return 'design';
      if (canvas.width !== WIDTH || canvas.height !== HEIGHT) return 'dimensions';
      if (Date.now() < quietAfter || [...document.querySelectorAll('.pplr_loader,.pplrloadingimage,.pplr_crop-modal,#pplr-preview-wrapper .pplr_loader')].some(visible)) return 'updating';
      return 'ready';
    };
    const messages = {
      loading: 'Kişiselleştirme alanı yükleniyor…',
      photo: 'Baskınızı hazırlamak için yukarıdan fotoğrafınızı yükleyin.',
      design: 'Seçtiğiniz modelin baskısı hazırlanıyor…',
      dimensions: 'Bu tasarımın baskı ölçüsü henüz hazır değil. Dosya indirme açıldığında buradan erişebilirsiniz.',
      updating: 'Önizleme güncelleniyor…',
      ready: `${WIDTH} × ${HEIGHT} piksel · PNG`,
    };
    const refresh = () => {
      if (exporting) return;
      const current = state();
      button.disabled = current !== 'ready';
      if (current !== lastState) {
        status.textContent = current === 'ready' && finishedMessage ? finishedMessage : messages[current];
        lastState = current;
      }
    };
    const changed = (event) => {
      const isDesignChange = designOption && event.target.closest?.(`product-info[data-product-id="${productId}"] variant-selects`);
      if (!isDesignChange && !event.target.closest?.(`#pplr-${productId},.pplr-wrapper,.pplr_cropper,#pplr-preview-wrapper`)) return;
      quietAfter = Date.now() + 1000;
      finishedMessage = '';
      lastState = '';
      refresh();
    };
    document.addEventListener('input', changed, true);
    document.addEventListener('change', changed, true);
    const chooseDesign = (event) => {
      if (!designOption) return;
      const swatch = event.target.closest?.(`#pplr-${productId} .pplr-swatch-element[data-val]`);
      if (!swatch || swatch.getAttribute('name') !== `properties[${designOption}]`) return;
      const product = document.querySelector(`product-info[data-product-id="${productId}"]`);
      const input = [...(product?.querySelectorAll('variant-selects input[type="radio"]') || [])].find(
        (element) => element.value === swatch.dataset.val
      );
      if (input && !input.checked) input.click();
      changed(event);
    };
    const designKey = (event) => {
      if (!designOption || !['Enter', ' '].includes(event.key)) return;
      if (!event.target.matches?.(`#pplr-${productId} .pplr-swatch-element[role="button"]`)) return;
      event.preventDefault();
      event.target.click();
    };
    document.addEventListener('click', chooseDesign);
    document.addEventListener('keydown', designKey);
    const redrawVariant = () => {
      if (!designOption) return;
      clearTimeout(variantRedraw);
      quietAfter = Date.now() + 1500;
      finishedMessage = '';
      lastState = '';
      refresh();
      // Zepto and the theme both react to variant changes. Redraw after the
      // native variant has settled so its refresh cannot restore an old image.
      variantRedraw = setTimeout(() => {
        const app = document.getElementById(`pplr-${productId}`);
        const field = app?.querySelector('input.pplr_text');
        field?.dispatchEvent(new Event('input', { bubbles: true }));
      }, 100);
    };
    document.addEventListener('variant:changed', redrawVariant);
    const timer = setInterval(() => {
      if (!root.isConnected) {
        clearInterval(timer);
        document.removeEventListener('input', changed, true);
        document.removeEventListener('change', changed, true);
        document.removeEventListener('click', chooseDesign);
        document.removeEventListener('keydown', designKey);
        document.removeEventListener('variant:changed', redrawVariant);
        clearTimeout(variantRedraw);
        return;
      }
      refresh();
    }, 300);
    refresh();
    button.addEventListener('click', async () => {
      if (state() !== 'ready' || exporting) return refresh();
      exporting = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = 'Baskı dosyanız hazırlanıyor…';
      try {
        await document.fonts.ready;
        await new Promise(requestAnimationFrame);
        if (state() !== 'ready') throw new Error('Önizleme değişti. Güncellenmesini bekleyip yeniden deneyin.');
        const canvas = getCanvas();
        const blob = await new Promise((resolve, reject) => canvas.toBlob((value) => value ? resolve(value) : reject(new Error('Baskı dosyası oluşturulamadı.')), 'image/png'));
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${root.dataset.filename || 'pasta'}-onizleme-${WIDTH}x${HEIGHT}.png`;
        root.append(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
        finishedMessage = 'Baskı dosyanız hazır. İndirmeler klasörünüzü kontrol edebilirsiniz.';
      } catch (error) {
        finishedMessage = error.name === 'SecurityError'
          ? 'Görsel indirilemedi. Fotoğrafınızı yeniden yükleyip tekrar deneyin.'
          : `${error.message || 'Baskı dosyası oluşturulamadı.'} Lütfen yeniden deneyin.`;
      } finally {
        exporting = false;
        button.removeAttribute('aria-busy');
        lastState = '';
        refresh();
      }
    });
  });
})();
